export default __webpack_public_path__ + "static/media/trickFasting.fd2cfc1e.svg";